import axiosInstance from "../axiosInstance";

export const PUTConfirmarReuIngresoPaletsManual = async (payload) => {
  try {
    const response = await axiosInstance.put(
      `${process.env.REACT_APP_WMS_BASE_URL}/ordenes/confirmar-reu-ingreso-palets`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default PUTConfirmarReuIngresoPaletsManual;
